"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrefundedDrawContributionMessageForEmail = exports.getPrefundedDrawContribution = void 0;
const _ = __importStar(require("lodash"));
const utils_1 = require("../utils");
// Works out to: receivable advance + cash advance - principal balance
const getPrefundedDrawContribution = ({ cashAdvanceRate, collectionsRecycleTotalAmount, currentPrincipalBalance, drawRequestTotalAmount, totalMaxAdvanceAmount, }) => {
    const maxSecuredDrawRequestAmount = _.round(totalMaxAdvanceAmount -
        currentPrincipalBalance -
        collectionsRecycleTotalAmount * cashAdvanceRate, 2);
    const roundedDrawRequestTotalAmount = _.round(drawRequestTotalAmount, 2);
    const prefundedDrawContribution = _.round(roundedDrawRequestTotalAmount - maxSecuredDrawRequestAmount, 2);
    if (roundedDrawRequestTotalAmount > 0 && prefundedDrawContribution > 0) {
        return prefundedDrawContribution;
    }
    return 0;
};
exports.getPrefundedDrawContribution = getPrefundedDrawContribution;
const getPrefundedDrawContributionMessageForEmail = ({ prefundedDrawContribution, }) => {
    let prefundedDrawContributionMessage;
    if (prefundedDrawContribution > 0) {
        const formattedPrefundedDrawContribution = (0, utils_1.numberToCurrencyWithSymbol)({
            number: prefundedDrawContribution,
        });
        prefundedDrawContributionMessage = `(includes prefunded draw\nof ${formattedPrefundedDrawContribution})`;
    }
    return prefundedDrawContributionMessage;
};
exports.getPrefundedDrawContributionMessageForEmail = getPrefundedDrawContributionMessageForEmail;
//# sourceMappingURL=index.js.map